<div *ngIf="place" class="profile place-profile">
  <div class="shadow-bottom">
    <div class="profile-details container">
      <div class="profile-info">
        <h1>
          <span>{{ place.practiceName }} <sup hcfFootnote [footnoteText]="place.notes" *ngIf="place.notes"></sup></span>
          <span
            *ngIf="place.isAffiliatedProvider"
            class="ic-status-affiliated"
            title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy."></span>
          <span
            *ngIf="place.isEasyClaim"
            class="ic-status-easy-claim"
            title="Easy-Claim partners provide a convenient way for
 Southern Cross members to claim for eligible
 healthcare services at the time of purchase."></span>
        </h1>
        <div
          class="ic-phone"
          *ngIf="place.phones && place.phones.length"
          [innerHTML]="place.phones | phoneArrayLinked"
          aria-label="Phone"></div>
        <div *ngIf="place.fax" class="ic-fax" aria-label="Fax">
          {{ place.fax }}
        </div>
        <div *ngIf="place.address" class="ic-address">
          <div class="facility-name" *ngIf="place.facilityName && place.facilityName !== place.address">
            {{ place.facilityName }}
          </div>
          <div *ngIf="place.receptionLocation">
            {{ place.receptionLocation }}
          </div>
          {{ place.address }}
          <div *ngIf="place.suburb">{{ place.suburb }}</div>
          <div *ngIf="place.city || place.postcode"> {{ place.city }} {{ place.postcode }} </div>
        </div>
        <div class="ic-web" *ngIf="place.webAddress">
          <a href="{{ place.webAddress }}" target="_newtab">{{ place.webAddress | webAddress }}</a>
        </div>
        <p class="report-problem">
          <a (click)="reportProblem()" class="cursor-pointer">Report incorrect details</a>
        </p>
      </div>
      <h3 [ngClass]="{ 'map-toggle': true, 'panel-expanded': mapExpanded }" (click)="toggleMap()">
        <span>View map</span>
      </h3>
      <!--ngIf is needed otherwise map is not initialised when hidden with css by default-->
      <hcf-map
        [places]="[location]"
        [ngClass]="{
          'profile-map toggle-panel': true,
          'panel-expanded': mapExpanded,
        }"
        *ngIf="mapExpanded"></hcf-map>
    </div>

    <div class="container">
      <div class="profile-details-message">
        <div class="profile-details-message-icon">
          <span class="ic-status-affiliated"></span>
        </div>
        <div class="profile-details-message-text">
          <strong class="reminder-content-ap-content-align"> Affiliated Provider (AP) healthcare facilities </strong>
          <div>
            Not all healthcare providers at this healthcare facility are contracted with us to perform every service.
            When booking, check that your healthcare provider is contracted with us to perform the healthcare service
            you need at this location.
          </div>
        </div>
      </div>

      <div class="profile-details-message">
        <div class="profile-details-message-icon">
          <span class="ic-status-easy-claim"></span>
        </div>
        <div class="profile-details-message-text">
          <strong class="reminder-content-ap-content-align"> Healthcare facilities offering Easy-Claim (EC) </strong>
          <div>
            You can authorise healthcare providers who offer Easy-Claim to claim on your behalf for eligible healthcare
            services at the time of purchase or service.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="profile-extras container">
    <div class="tabs" *ngIf="hasPeople || hasServices">
      <a
        class="tab-button"
        (click)="onTabCLick(tabType.doctors)"
        *ngIf="hasPeople"
        [class.selected]="selectedTab == tabType.doctors"
        >Doctors</a
      ><a
        (click)="onTabCLick(tabType.services)"
        class="tab-button"
        *ngIf="hasServices"
        [class.selected]="selectedTab == tabType.services"
        >Services</a
      >
    </div>
    <div
      [ngClass]="{
        'tab-content': true,
        hidden: selectedTab != tabType.doctors,
      }">
      <hcf-person-by-service-category
        [serviceCategory]="serviceCategory"
        [placeDetail]="place"
        *ngFor="let serviceCategory of placeServiceCategoriesByPerson; let i = index"
        [componentIndex]="i"
        [numberOfServiceCategories]="numberOfServiceCategoriesByPerson"></hcf-person-by-service-category>
    </div>
    <div
      [ngClass]="{
        'tab-content': true,
        hidden: selectedTab != tabType.services,
      }">
      <hcf-place-service-category
        [serviceCategory]="serviceCategory"
        *ngFor="let serviceCategory of placeServiceCategoriesByService; let i = index"
        [componentIndex]="i"
        [numberOfServiceCategories]="numberOfServiceCategoriesByService"></hcf-place-service-category>
    </div>

    <hcf-footnotes [footnotes]="footnotes" *ngIf="footnotes && footnotes.length > 0"></hcf-footnotes>
  </div>
</div>
<hcf-popup #reportProblemPopupComponent>
  <hcf-report-form [person]="" [personFullName]="" [place]="place"></hcf-report-form>
</hcf-popup>
